import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";
import { omit } from "lodash-es";

import { newScimAccesses, newScimFilters } from "../scim/accesses.ts";
import { GrafanaCloudComponents } from "./components.ts";

const label = "Grafana Cloud";

const scimArgs = {
  entitlement: { label: "N/A" },
  group: { label: "Team", description: "Grafana Cloud team" },
  locator: {
    label: "Organization",
    description: "Grafana Cloud organization identifier",
  },
  name: label,
};

const accesses = omit(newScimAccesses(scimArgs), "entitlement");
const filters = omit(newScimFilters(scimArgs), "entitlement");

export const GrafanaCloudRegistration = Registration({
  accesses,
  category: "resource",
  components: GrafanaCloudComponents,
  docs: {},
  filters,
  itemKind: "organization",
  label,
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/3/3b/Grafana_icon.svg",
  maturity: "preview",
  useMapping: [{ use: "iam_write", component: "scim" }],
  requestType: "requestable",
});

registerIntegration("grafana-cloud", GrafanaCloudRegistration);
